import { Award, Factory, MapPin, Ruler, ShieldCheck, Truck } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: Award, title: "10+ Years", text: "Fabrication experience" },
  { icon: Factory, title: "In-House", text: "Fabrication shop" },
  { icon: Ruler, title: "Laser", text: "Digital templating" },
  { icon: Truck, title: "Pro Install", text: "Our own crew" },
  { icon: ShieldCheck, title: "BBB A+", text: "Accredited business" },
  { icon: MapPin, title: "KS & MO", text: "Kansas City metro" },
];

export const TrustBar = () => (
  <section aria-label="Why homeowners trust us" data-testid="trust-bar" className="border-y border-white/[0.06] bg-[#0E131D]">
    <ul className="mx-auto grid max-w-[1400px] grid-cols-2 sm:grid-cols-3 lg:grid-cols-6">
      {ITEMS.map(({ icon: Icon, title, text }, i) => (
        <Reveal as="li" key={title} delay={i * 0.06} y={12} className="flex items-center gap-3 border-white/[0.06] px-5 py-6 [&:not(:last-child)]:border-r sm:px-6">
          <Icon className="h-5 w-5 shrink-0 text-[#CDA85B]" strokeWidth={1.4} />
          <span>
            <span className="block font-display text-xl leading-none text-[#F5F0E6]">{title}</span>
            <span className="mt-1 block text-xs text-[#AEB3BC]">{text}</span>
          </span>
        </Reveal>
      ))}
    </ul>
  </section>
);
